(() => {
  if (customElements.get('ss-collection-atlas')) return;
  class CollectionAtlas extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const signal = this.abort.signal;
      this.tabs = [...this.querySelectorAll('[data-atlas-tab]')];
      this.panels = [...this.querySelectorAll('[data-atlas-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('nav').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab'); tab.id = tab.dataset.panel + '-tab';
        tab.setAttribute('aria-controls', tab.dataset.panel);
        const panel = this.panels.find(p => p.id === tab.dataset.panel);
        panel?.setAttribute('role', 'tabpanel'); panel?.setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); this.select(index); this.panels.find(panel => !panel.hidden)?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }, { signal });
        tab.addEventListener('keydown', event => {
          let next = index;
          const columns = getComputedStyle(this.querySelector('nav')).gridTemplateColumns.split(' ').length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'ArrowDown') next = Math.min(this.tabs.length - 1, index + columns);
          else if (event.key === 'ArrowUp') next = Math.max(0, index - columns);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); this.select(index); return; }
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        }, { signal });
      });
      this.select(0);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach(panel => { panel.hidden = panel.id !== this.tabs[index].dataset.panel; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('ss-collection-atlas', CollectionAtlas);
  function decorate(root = document) { root.querySelectorAll('[data-ss-living-store] .ai-showroom__inner, [data-ss-living-store] .ss-car-display').forEach(element => element.setAttribute('data-ss-motion', '')); }
  decorate();
  document.addEventListener('shopify:section:load', event => { decorate(event.target); document.dispatchEvent(new Event('visibilitychange')); });
})();
